<div class="to-top-container" (click)="onTop()">
    <mat-icon class="icon" svgIcon="chevron-right" style="color: black; transform: rotate(270deg)"></mat-icon>
    <div class="text title">{{ 'dlg.top' | translate }}</div>
</div>
